/**
 * Icônes du parcours Tarifs → Panier, tracés de la maquette /msc (`PUNCH_UI.P`, trait 1,8,
 * `currentColor`). Décoratives : aria-hidden, le libellé est porté par le texte voisin.
 */
const PATHS = {
  check: 'M20 6 9 17l-5-5',
  right: 'm9 18 6-6-6-6',
  left: 'm15 18-6-6 6-6',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM12 16.5V11M12 7.6v.1',
  lock: 'M5 11h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1ZM8 11V7a4 4 0 0 1 8 0v4',
  close: 'M18 6 6 18M6 6l12 12',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 17, stroke = 1.8 }: { name: IconName; size?: number; stroke?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
